// A context still pending (chained off a field not set yet) carries an empty pk; engine components throw on one.
export function hasCompletePk(pk) {
  return Boolean(pk) && typeof pk === "object" && Object.keys(pk).length > 0
    && Object.values(pk).every(value => value !== null && value !== undefined && value !== "");
}
